// import dayjs from 'dayjs';
/**
 * 搜索模型
 */
export function createSearchModel() {
  return {
    isExcep: 2, // 是否需要包含异常的数据
    queryId: 21, // 接口请求的 请求id
    // 查商品 特殊字段
    needOrder: 1, // 查询 订单 + 商品数据 这里传1的话 方便拿商品数据

    // 普通字段
    userId: [], // 店铺名称
    secondUserId: [], // 奇门子店铺所需参数
    sellerNicks: [], // 奇门子店铺所需参数
    subSources: [], // 奇门子店铺所需参数
    sid: '', // 系统订单号
    tid: '', // 平台交易号
    buyerNickType: 1, // 买家昵称类型
    buyerNick: '', //买家昵称
    expressCompanyIds: [], // 快递公司
    outSid: '', // 快递单号
    destId: [], //供销商
    sourceId: [], //分销商
    timeType: 'pay_time', // (付款时间:pay_time | 审核时间:audit_time | 发货时间:consign_time)
    startTime: '', //开始时间
    endTime: '', //结束时间
    key: 'itemTitle', // 快捷查询类型
    queryType: 0, // 0模糊查询 | 1精确查询
    text: '', // 文本内容
    skuProp: '', // 选择商品名称的时候  才有的 规格
    platSkuProp: '', // 选择平台名称的时候  才有的 规格
    itemTitle: '', // 选择平台规格的时候  才有的 商品名称
    itemType: 0, // 商家编码的时候  才有的
    needAllocateStock: 1, // 库存

    // 表格内容 表头
    itemOrder: '', // 商品信息 (单品排序:single | 多规格排序:multi)
    order: '', // 时间排序 (网店付款时间 升序:asc | 降序:desc )
    sellerFlag: [], //旗帜  选择包含
    excludeSellerFlags: [], // 旗帜  选择不包含
    hasBuyerMessage: '', // 0无留言 | 1有留言
    hasSellerMemo: '', // 0无备注 | 1有备注
    express: [], // 物流信息 已分配快递-2 | 未分配快递-1
    containOutSid: '', // 物流信息 有运单号1 | 无运单号0
    tradeType: [], //订单类型 包含 // 只服务于
    excludeTradeType: [], //订单类型 排除包含
    itemCountStart: '', // 商品数量开始
    itemCountEnd: '', // 商品数量结束
    itemKindStart: '', // 商品种类开始
    itemKindEnd: '', // 商品种类开始
    paymentLowerLimit: '', // 实付金额 开始
    paymentUpperLimit: '', // 实付金额 结束
    tagIds: [], // 订单标签 包含
    excludeTagIds: [], //  订单标签 排除

    // 状态
    sysStatus: [],
    exceptionStatus: [], // 异常
    exceptIds: [], // 自定义异常
    expressStatus: '', // 打印状态

    // 物流预警参数
    // { days, logisticsWarningType, warningTypeInterval }
    logisticsWarningParams: null,

    // 自定义
    customTime: {
      select: 'pay_time', // 默认展示 付款时间
      start: '',
      end: '', //dayjs().add(1, 'day').startOf('day').unix() * 1000 - 59,
    },

    // 分销或自发或供销单筛选(前端使用，需要再请求前做处理)
    // excludeTradeType: 33 自发
    // tradeType:33,48 代发
    selfSendOrNot: '', // '':全部 'notSelf':分销 'self':自发 'gxOrder':供销订单
  };
}

/**
 * 分页数据
 * @returns Object
 */
export const createPagination = () => ({
  total: 0,
  pageNo: 1,
  pageSize: 50,
});
